import { Controller } from "@hotwired/stimulus";
import { dsConfirm } from "../../utils/ds_confirm";
import { normalizeText, smartMatch } from "../../utils/smart_search";

export default class extends Controller {
  static targets = ["areasList", "filterInput"];

  connect() {
    console.log("inventory_assignment_controller connected");
    // Set up initial state when controller connects
    this.originalRows = Array.from(
      this.areasListTarget.querySelectorAll("tr.area-row")
    );
  }

  filterAreas() {
    const filterValue = normalizeText(this.filterInputTarget.value);
    if (!filterValue) {
      // If filter is empty, show all rows
      this.originalRows.forEach((row) => row.classList.remove("hidden"));
      return;
    }

    // Filter rows based on location name text
    this.originalRows.forEach((row) => {
      const locationName = row
        .querySelector("td:first-child div:first-child")
        .textContent;
      const locationDetails =
        row.querySelector("td:first-child div:nth-child(2)")?.textContent ||
        "";

      if (smartMatch([locationName, locationDetails], filterValue)) {
        row.classList.remove("hidden");
      } else {
        row.classList.add("hidden");
      }
    });
  }

  async clearAssignments() {
    if (!(await dsConfirm("Are you sure you want to clear all assignments?", { tone: "danger" }))) {
      return;
    }

    // Clear all select elements
    const selectElements = this.areasListTarget.querySelectorAll("select");
    selectElements.forEach((select) => {
      select.value = "";
    });
  }
}
